import { useEffect, useState } from "react";
import { formatNumber } from "../../shared/utils";
import { RatingReviews } from "./RatingReviews";

export const ProductItem = ({ product, isHighlighted, sortBy, addToCard }) => {
  const {
    image = "",
    title = "",
    rating = 0,
    reviews = 0,
    price = 0,
    unit = "",
    unit_price = 0,
    capacity_per_pack = 0,
    key = "",
  } = product || {};
  const isBestValue = sortBy === "bestValue";
  const [count, setCount] = useState(0);
  const [productKey, setProductKey] = useState("");

  useEffect(() => {
    setCount(0);
  }, [sortBy]);

  // useEffect(() => {
  //   if (isHighlighted) {
  //     increase(key);
  //   } else {
  //     decrease(key);
  //   }
  // }, [sortBy,isHighlighted]);

  useEffect(() => {
    addToCard({
      productKey: productKey,
      quantity: count,
      price: price,
      productTitle: title,
      store: "Amazon",
      unitPrice: unit_price,
    });
  }, [count, productKey]);

  const decrease = (key) => {
    if (count > 0) {
      setCount((prev) => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
      setProductKey(key);
    }
  };

  const increase = (key) => {
    if (count < 100) {
      setCount((prev) => prev + 1);
      setProductKey(key);
    }
  };

  return (
    <div
      className={`
        relative bg-white rounded-[12px]
        m-[5px] flex flex-col
        w-[180px]
        sm:w-[260px]
        md:w-[200px]
        flex-shrink-0
        border-2
        shadow-[0_2px_8px_rgba(0,0,0,0.12)]
        ${isHighlighted ? "border-teal-400" : "border-transparent"}
      `}
    >
      {isHighlighted && (
        <div
          className={`${"bg-teal-400"} rounded-t-lg items-center text-center text-xs py-0.5`}
        >
          {isBestValue ? "🏆 Best Value" : "💰 Budget"}
        </div>
      )}
      {/* Product Image */}
      <div className={`px-[10px] ${isHighlighted ? "py-[10px]" : "py-[30px]"}`}>
        <img
          src={image}
          alt="Product"
          className="w-full h-[150px] object-contain object-center rounded-lg"
        />

        {/* Product Title */}
        <h3 className="mt-3 text-xs sm:text-sm text-gray-800 line-clamp-3 leading-snug min-h-[3.6em] sm:min-h-[4.2em]">
          {title}
        </h3>

        {/* Rating & Weight */}
        <div className="flex items-center justify-between mt-2 whitespace-nowrap">
          {rating > 0 ? (
            <RatingReviews rating={rating} reviews={reviews} />
          ) : (
            <div></div>
          )}

          {/* Weight */}
          <div className="bg-black text-white text-[10px] sm:text-xs px-1.5 py-0.5 rounded-[6px] shrink-0 gap-1">
            {`${capacity_per_pack} ${unit}`}
          </div>
        </div>

        {/* Per Oz Info */}
        <div className="mt-3 rounded-[10px] px-3 py-2 text-center bg-teal-400/30">
          <p className="text-xs font-medium text-black">Per {unit}</p>
          <p className="text-sm font-semibold text-black">
            ${Number(unit_price).toFixed(2)}
          </p>
        </div>

        <div className="flex items-center justify-between mt-3">
          {/* Price */}
          <p className="text-base font-bold text-gray-900 mr-8">
            ${price.toFixed(2)}
          </p>

          {count === 0 ? (
            <button className="bg-[#2DD4BF] text-white font-semibold text-xs px-2.5 py-2 rounded-[10px] shadow-md"
              onClick={() => {
                increase(key);
              }}
            >
              + Add
            </button>
          ) : (
            <div className="flex items-center bg-gray-100 rounded-[6px] min-w-[60px] justify-between">
              <button
                onClick={() => {
                  decrease(key);
                }}
                className="px-3 text-lg text-red-700 font-semibold"
              >
                −
              </button>

              <span className="w-6 text-center text-sm font-medium text-gray-900">
                {count}
              </span>

              <button
                onClick={() => {
                  increase(key);
                }}
                className="px-3 text-lg font-semibold text-green-700"
              >
                +
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
